import React from 'react';
export function FooterSection() {
  return <footer className="bg-[#071A14] py-4 px-2 text-center border-t-2 border-[#D4A843]" data-id="element-47">
      <div className="max-w-4xl mx-auto" data-id="element-48">
        <p className="font-black text-[#FFFFFF] mb-1 text-xs md:text-sm uppercase tracking-widest leading-none" data-id="element-49">
          🌱 KIT COMPLETO EDUCACIÓN AMBIENTAL RURAL APLICADA
        </p>
        <p className="text-[#BFC9C5] font-bold text-[8px] md:text-[9px] mb-2 uppercase leading-none" data-id="element-50">
          © 2026 Todos los derechos reservados.
        </p>
        <div className="flex justify-center gap-3 text-[8px] font-bold text-[#74C69D] uppercase tracking-wider" data-id="element-51">
          <span className="cursor-pointer hover:text-[#D4A843] transition-colors" data-id="element-52">
            Términos y Condiciones
          </span>
          <span className="cursor-pointer hover:text-[#D4A843] transition-colors" data-id="element-53">
            Políticas de Privacidad
          </span>
        </div>
      </div>
    </footer>;
}